import { apiRequest } from '@/services/http'

/** `bs-talent.exclusion_grants` — "Blocked Companies". */
export interface Exclusion {
  _id: string
  excludedType: 'company' | 'recruiter'
  excludedId: string
  excludedName?: string
  excludedLogoUrl?: string
  reason?: string
  createdAt: string
}

export interface CreateExclusionInput {
  excludedType: 'company' | 'recruiter'
  excludedId: string
  excludedName?: string
  excludedLogoUrl?: string
  reason?: string
}

export function getExclusions(): Promise<{ items: Exclusion[] }> {
  return apiRequest('/v1/exclusions')
}
export function createExclusion(input: CreateExclusionInput): Promise<{ exclusion: Exclusion }> {
  return apiRequest('/v1/exclusions', { method: 'POST', body: JSON.stringify(input) })
}
export function removeExclusion(id: string): Promise<{ ok: boolean }> {
  return apiRequest(`/v1/exclusions/${id}`, { method: 'DELETE' })
}
